import { ThemeProps } from '../../types/themeProps'
import defaultTheme from '../defaultTheme'

const trpTheme: ThemeProps = {
  ...defaultTheme,
}

export default trpTheme
